import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import { useAuth } from './AuthContext';
import api from '../services/api';
import BadgeCelebrationModal from '../components/Common/BadgeCelebrationModal';

const BadgeCelebrationContext = createContext();

export const useBadgeCelebration = () => useContext(BadgeCelebrationContext);

export const BadgeCelebrationProvider = ({ children }) => {
  const { user } = useAuth();
  const [queue, setQueue] = useState([]);
  const [currentBadge, setCurrentBadge] = useState(null);
  const checkingRef = useRef(false);

  const showNext = useCallback((badges) => {
    if (badges.length === 0) {
      setCurrentBadge(null);
      return;
    }
    setCurrentBadge(badges[0]);
    setQueue(badges.slice(1));
  }, []);

  const handleDismiss = useCallback(() => {
    setQueue(prev => {
      if (prev.length > 0) {
        setCurrentBadge(prev[0]);
        return prev.slice(1);
      }
      setCurrentBadge(null);
      return [];
    });
  }, []);

  const checkBadges = useCallback(async () => {
    if (!user?.uid || checkingRef.current) return;
    checkingRef.current = true;

    try {
      const response = await api.post(`/badges/check/${user.uid}`);
      const newBadges = response.data?.newBadges || [];
      if (newBadges.length > 0) {
        showNext(newBadges);
      }
    } catch (error) {
      console.error('Error checking badges:', error);
    } finally {
      checkingRef.current = false;
    }
  }, [user?.uid, showNext]);

  return (
    <BadgeCelebrationContext.Provider value={{ checkBadges }}>
      {children}
      <BadgeCelebrationModal
        badge={currentBadge}
        remaining={queue.length}
        onDismiss={handleDismiss}
      />
    </BadgeCelebrationContext.Provider>
  );
};
